<section class="order-container container-fluid">

    <div class="page-header">
        <h3 translate="cart.order.history"></h3>
        <span translate="cart.order.history.range"></span>

        <select [ngModel]="selectedDateRange()" (ngModelChange)="onDateRangeChange($event)" class="form-select" automation-tag="sortDropDown">
            @for (dateRange of dateRanges(); track $index) {
                <option [ngValue]="dateRange">{{dateRange.display}}</option>
            }
        </select>
    </div>

    @if (loading()) {
        <div class="spacer text-center">
            <usana-spinner [show]="loading()" [delay]="0"></usana-spinner>
        </div>
    }

    @if (!loading() && !orderViews()?.length) {
        <div class="panel panel-default">
            <div class="panel-body" translate="cart.order.history.empty"></div>
        </div>
    }

    @if (!loading() && orderViews()?.length) {
        @for (orderView of orderViews(); track orderView.id) {
            <div>
                <div id="order{{orderView.id}}" class="panel panel-default">

                    <div class="panel-heading">
                        <span class="pull-left" translate="cart.order.history.order.placed"></span><span class="fw-bold">&nbsp;{{orderView.orderDate | usanadate: 'mediumDate':orderView.warehouse?.timezone | async}}</span>
                        <a (click)="setActiveOrderView(orderView)"
                           [routerLink]="[ORDER_HISTORY_DETAILS_ROUTE, orderView.id]"
                           translate="cart.order.history.order.details"></a>
                    </div>

                    <div class="order-summary-container">
                        <order-history-product-row
                            (itemAdded)="addItemToCart($event, orderView.id)"
                            [headerLabels]="headerLabels"
                            [displayVolume]="displayVolume()"
                            [displayAttributes]="productDisplayAttributes"
                            [orderView]="orderView"></order-history-product-row>

                        <order-history-summary
                            (addFullOrder)="addFullOrderToCart($event, orderView.id)"
                            (viewTracking)="viewTracking($event)"
                            (managePayment)="managePayment($event)"
                            [orderView]="orderView"
                            [trackingCount]="trackingCounts().get(orderView.id) ?? 0"
                            [canAutoOrder]="canManageAutoOrder()"
                            [canPayPending]="canPayPending()"
                            [displayVolume]="displayVolume()"></order-history-summary>
                    </div>
                </div>
            </div>
        }
    }

</section>
